import { render, staticRenderFns } from "./AssignedRoutineView.vue?vue&type=template&id=2366713e&"
import script from "./AssignedRoutineView.vue?vue&type=script&lang=ts&"
export * from "./AssignedRoutineView.vue?vue&type=script&lang=ts&"
import style0 from "./AssignedRoutineView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VBtn,VCard,VContent})
